
import { createRoot } from 'react-dom/client'
import ready from 'document-ready-promise'
import 'setup/modern_globals'

import { LoginPage } from 'mc-app/saml/login'

ready().then(() => {


  const pages = {
    "SamlLoginPage": LoginPage
  }

  Object.entries(pages).forEach(([id, Component]) => {
    const container = document.getElementById(id)
    if (!container) return

    const props = JSON.parse(container.dataset.props || '{}')

    createRoot(container).render(<Component {...props} />)
  })

})
